import { TMS_THEME } from "../theming/theming";
import { useStylesHook } from "./useStylesHook";
/** Be consistent Tailwinds naming structure where possible - https://tailwindcss.com/docs
 * For ease of understanding don't use the single letter example from Tailwind and replace
 * with a name, eg pr is rightPadding
 *
 * Any padding or margin added to the Styles option should be based of the BASE_SIZE of 4px.
 * We default the Margin / Space and Padding to 12px.
 */
export var UtilityStyle;
(function (UtilityStyle) {
    UtilityStyle["Relative"] = "relative";
    UtilityStyle["Absolute"] = "absolute";
    UtilityStyle["Block"] = "block";
    UtilityStyle["Flex"] = "flex";
    UtilityStyle["InlineBlock"] = "inlineBlock";
    UtilityStyle["ItemsCenter"] = "itemsCenter";
    UtilityStyle["AlignMiddle"] = "alignMiddle";
    UtilityStyle["JustifyBetween"] = "justifyBetween";
    UtilityStyle["SelfBaseline"] = "selfBaseline";
    UtilityStyle["Shrink"] = "shrink";
    UtilityStyle["ShrinkZero"] = "shrinkZero";
    UtilityStyle["SelfCenter"] = "selfCenter";
    UtilityStyle["FloatRight"] = "floatRight";
    UtilityStyle["Clear"] = "clear";
    UtilityStyle["HorizontalPaddingZero"] = "horizontalPaddingZero";
    UtilityStyle["HorizontalPaddingSmall"] = "horizontalPaddingSmall";
    UtilityStyle["HorizontalPaddingMedium"] = "horizontalPaddingMedium";
    UtilityStyle["HorizontalPadding"] = "horizontalPadding";
    UtilityStyle["HorizontalPaddingLarge"] = "horizontalPaddingLarge";
    UtilityStyle["VerticalPaddingZero"] = "verticalPaddingZero";
    UtilityStyle["VerticalPaddingSmall"] = "verticalPaddingSmall";
    UtilityStyle["VerticalPaddingMedium"] = "verticalPaddingMedium";
    UtilityStyle["VerticalPadding"] = "verticalPadding";
    UtilityStyle["VerticalPaddingLarge"] = "verticalPaddingLarge";
    UtilityStyle["FlexOne"] = "flexOne";
    UtilityStyle["RightSpaceLarge"] = "rightSpaceLarge";
    UtilityStyle["LeftSpaceLarge"] = "leftSpaceLarge";
    UtilityStyle["BottomSpaceLarge"] = "bottomSpaceLarge";
    UtilityStyle["TopSpaceLarge"] = "topSpaceLarge";
    UtilityStyle["RightSpace"] = "rightSpace";
    UtilityStyle["LeftSpace"] = "leftSpace";
    UtilityStyle["BottomSpace"] = "bottomSpace";
    UtilityStyle["TopSpace"] = "topSpace";
    UtilityStyle["RightSpaceMedium"] = "rightSpaceMedium";
    UtilityStyle["LeftSpaceMedium"] = "leftSpaceMedium";
    UtilityStyle["BottomSpaceMedium"] = "bottomSpaceMedium";
    UtilityStyle["TopSpaceMedium"] = "topSpaceMedium";
    UtilityStyle["RightSpaceSmall"] = "rightSpaceSmall";
    UtilityStyle["LeftSpaceSmall"] = "leftSpaceSmall";
    UtilityStyle["BottomSpaceSmall"] = "bottomSpaceSmall";
    UtilityStyle["TopSpaceSmall"] = "topSpaceSmall";
    UtilityStyle["RightSpaceZero"] = "rightSpaceZero";
    UtilityStyle["LeftSpaceZero"] = "leftSpaceZero";
    UtilityStyle["BottomSpaceZero"] = "bottomSpaceZero";
    UtilityStyle["TopSpaceZero"] = "topSpaceZero";
    UtilityStyle["RightSpaceAuto"] = "rightSpaceAuto";
    UtilityStyle["LeftSpaceAuto"] = "leftSpaceAuto";
    UtilityStyle["BottomSpaceAuto"] = "bottomSpaceAuto";
    UtilityStyle["TopSpaceAuto"] = "topSpaceAuto";
    UtilityStyle["HeaderFont"] = "headerFont";
    UtilityStyle["TextCenter"] = "textCenter";
    UtilityStyle["Truncate"] = "truncate";
    UtilityStyle["FontLight"] = "fontLight";
    UtilityStyle["FontNormal"] = "fontNormal";
    UtilityStyle["FontBold"] = "fontBold";
    UtilityStyle["TextLarge"] = "textLarge";
    UtilityStyle["TextBlack"] = "textBlack";
    UtilityStyle["TextSlate"] = "textSlate";
    UtilityStyle["TextCharcoal"] = "textCharcoal";
    UtilityStyle["TextSilver"] = "textSilver";
    UtilityStyle["TextSmoke"] = "textSmoke";
    UtilityStyle["TextCloud"] = "textCloud";
    UtilityStyle["TextFog"] = "textFog";
    UtilityStyle["TextMist"] = "textMist";
    UtilityStyle["TextWhite"] = "textWhite";
    UtilityStyle["BackgroundBlack"] = "backgroundBlack";
    UtilityStyle["BackgroundSlate"] = "backgroundSlate";
    UtilityStyle["BackgroundCharcoal"] = "backgroundCharcoal";
    UtilityStyle["BackgroundSilver"] = "backgroundSilver";
    UtilityStyle["BackgroundSmoke"] = "backgroundSmoke";
    UtilityStyle["BackgroundCloud"] = "backgroundCloud";
    UtilityStyle["BackgroundFog"] = "backgroundFog";
    UtilityStyle["BackgroundMist"] = "backgroundMist";
    UtilityStyle["BackgroundWhite"] = "backgroundWhite";
    UtilityStyle["Border"] = "border";
    UtilityStyle["BottomBorderZero"] = "bottomBorderZero";
    UtilityStyle["TopBorderZero"] = "topBorderZero";
    UtilityStyle["RightBorderZero"] = "rightBorderZero";
    UtilityStyle["LeftBorderZero"] = "leftBorderZero";
})(UtilityStyle || (UtilityStyle = {}));
export const useUtilityStyles = (config) => {
    let utilities = {};
    let multipleUtilities = {};
    config?.forEach((option) => {
        if (typeof option !== "object") {
            utilities = { ...utilities, ...STYLES_MAP[option] };
        }
        else {
            multipleUtilities = {
                ...multipleUtilities,
                ...option,
            };
        }
    });
    let utilitiesWithStyles = {};
    Object.keys(multipleUtilities).forEach((className) => {
        let utilities = {};
        if (className === "utilities") {
            throw new Error("[piston-ux] utilities is a protected class name");
        }
        multipleUtilities[className].forEach((option) => {
            utilities = { ...utilities, ...STYLES_MAP[option] };
        });
        utilitiesWithStyles = {
            ...utilitiesWithStyles,
            ...{ [className]: utilities },
        };
    });
    return useStylesHook({ utilities, ...utilitiesWithStyles });
};
export const hasUtilityStyle = (componentStyles, toFind) => !!componentStyles?.find((style) => style === toFind);
export const BASE_SIZE = 4;
export const SMALL_SIZE = BASE_SIZE;
export const MEDIUM_SIZE = BASE_SIZE * 2;
export const DEFAULT_SIZE = BASE_SIZE * 3;
export const LARGE_SIZE = BASE_SIZE * 4;
const cssPixelValue = (value) => `${value}px !important`;
export const STYLES_MAP = {
    [UtilityStyle.Relative]: { position: "relative !important" },
    [UtilityStyle.Absolute]: { position: "absolute !important" },
    [UtilityStyle.Block]: { display: "block !important" },
    [UtilityStyle.InlineBlock]: { display: "inline-block !important" },
    [UtilityStyle.Flex]: { display: "flex !important" },
    [UtilityStyle.ItemsCenter]: { alignItems: "center !important" },
    [UtilityStyle.JustifyBetween]: { justifyContent: "space-between !important" },
    [UtilityStyle.SelfBaseline]: { alignSelf: "baseline !important" },
    [UtilityStyle.SelfCenter]: { alignSelf: "center !important" },
    [UtilityStyle.Shrink]: { flexShrink: "1 !important" },
    [UtilityStyle.ShrinkZero]: { flexShrink: "0 !important" },
    [UtilityStyle.TextCenter]: { textAlign: "center !important" },
    [UtilityStyle.FloatRight]: { float: "right !important" },
    [UtilityStyle.Clear]: { clear: "both !important" },
    [UtilityStyle.AlignMiddle]: { verticalAlign: "middle !important" },
    [UtilityStyle.HeaderFont]: {
        fontFamily: "var(--font-family-header) !important",
    },
    [UtilityStyle.FontLight]: { fontWeight: "300 !important" },
    [UtilityStyle.FontNormal]: { fontWeight: "400 !important" },
    [UtilityStyle.FontBold]: { fontWeight: "500 !important" },
    [UtilityStyle.TextBlack]: {
        color: `${TMS_THEME.palette.gray.black.color} !important`,
    },
    [UtilityStyle.TextSlate]: {
        color: `${TMS_THEME.palette.gray.slate.color} !important`,
    },
    [UtilityStyle.TextCharcoal]: {
        color: `${TMS_THEME.palette.gray.charcoal.color} !important`,
    },
    [UtilityStyle.TextSilver]: {
        color: `${TMS_THEME.palette.gray.silver.color} !important`,
    },
    [UtilityStyle.TextSmoke]: {
        color: `${TMS_THEME.palette.gray.smoke.color} !important`,
    },
    [UtilityStyle.TextCloud]: {
        color: `${TMS_THEME.palette.gray.cloud.color} !important`,
    },
    [UtilityStyle.TextFog]: {
        color: `${TMS_THEME.palette.gray.fog.color} !important`,
    },
    [UtilityStyle.TextMist]: {
        color: `${TMS_THEME.palette.gray.mist.color} !important`,
    },
    [UtilityStyle.TextWhite]: {
        color: `${TMS_THEME.palette.gray.white.color} !important`,
    },
    [UtilityStyle.BackgroundBlack]: {
        backgroundColor: `${TMS_THEME.palette.gray.black.color} !important`,
    },
    [UtilityStyle.BackgroundSlate]: {
        backgroundColor: `${TMS_THEME.palette.gray.slate.color} !important`,
    },
    [UtilityStyle.BackgroundCharcoal]: {
        backgroundColor: `${TMS_THEME.palette.gray.charcoal.color} !important`,
    },
    [UtilityStyle.BackgroundSilver]: {
        backgroundColor: `${TMS_THEME.palette.gray.silver.color} !important`,
    },
    [UtilityStyle.BackgroundSmoke]: {
        backgroundColor: `${TMS_THEME.palette.gray.smoke.color} !important`,
    },
    [UtilityStyle.BackgroundCloud]: {
        backgroundColor: `${TMS_THEME.palette.gray.cloud.color} !important`,
    },
    [UtilityStyle.BackgroundFog]: {
        backgroundColor: `${TMS_THEME.palette.gray.fog.color} !important`,
    },
    [UtilityStyle.BackgroundMist]: {
        backgroundColor: `${TMS_THEME.palette.gray.mist.color} !important`,
    },
    [UtilityStyle.BackgroundWhite]: {
        backgroundColor: `${TMS_THEME.palette.gray.white.color} !important`,
    },
    [UtilityStyle.TextLarge]: {
        fontSize: cssPixelValue(TMS_THEME.typography.h3.fontSize),
    },
    [UtilityStyle.Truncate]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    [UtilityStyle.Border]: {
        border: `1px solid ${TMS_THEME.palette.gray.smoke.color} !important`,
    },
    [UtilityStyle.BottomBorderZero]: { borderBottom: `0px !important` },
    [UtilityStyle.TopBorderZero]: { borderTop: `0px !important` },
    [UtilityStyle.RightBorderZero]: { borderRight: `0px !important` },
    [UtilityStyle.LeftBorderZero]: { borderLeft: `0px !important` },
    [UtilityStyle.HorizontalPaddingZero]: {
        paddingLeft: cssPixelValue(0),
        paddingRight: cssPixelValue(0),
    },
    [UtilityStyle.HorizontalPaddingSmall]: {
        paddingLeft: cssPixelValue(SMALL_SIZE),
        paddingRight: cssPixelValue(SMALL_SIZE),
    },
    [UtilityStyle.HorizontalPaddingMedium]: {
        paddingLeft: cssPixelValue(MEDIUM_SIZE),
        paddingRight: cssPixelValue(MEDIUM_SIZE),
    },
    [UtilityStyle.HorizontalPadding]: {
        paddingLeft: cssPixelValue(DEFAULT_SIZE),
        paddingRight: cssPixelValue(DEFAULT_SIZE),
    },
    [UtilityStyle.HorizontalPaddingLarge]: {
        paddingLeft: cssPixelValue(LARGE_SIZE),
        paddingRight: cssPixelValue(LARGE_SIZE),
    },
    [UtilityStyle.VerticalPaddingZero]: {
        paddingTop: cssPixelValue(0),
        paddingBottom: cssPixelValue(0),
    },
    [UtilityStyle.VerticalPaddingSmall]: {
        paddingTop: cssPixelValue(SMALL_SIZE),
        paddingBottom: cssPixelValue(SMALL_SIZE),
    },
    [UtilityStyle.VerticalPaddingMedium]: {
        paddingTop: cssPixelValue(MEDIUM_SIZE),
        paddingBottom: cssPixelValue(MEDIUM_SIZE),
    },
    [UtilityStyle.VerticalPadding]: {
        paddingTop: cssPixelValue(DEFAULT_SIZE),
        paddingBottom: cssPixelValue(DEFAULT_SIZE),
    },
    [UtilityStyle.VerticalPaddingLarge]: {
        paddingTop: cssPixelValue(LARGE_SIZE),
        paddingBottom: cssPixelValue(LARGE_SIZE),
    },
    [UtilityStyle.RightSpaceLarge]: { marginRight: cssPixelValue(LARGE_SIZE) },
    [UtilityStyle.LeftSpaceLarge]: { marginLeft: cssPixelValue(LARGE_SIZE) },
    [UtilityStyle.BottomSpaceLarge]: { marginBottom: cssPixelValue(LARGE_SIZE) },
    [UtilityStyle.TopSpaceLarge]: { marginTop: cssPixelValue(LARGE_SIZE) },
    [UtilityStyle.RightSpace]: { marginRight: cssPixelValue(DEFAULT_SIZE) },
    [UtilityStyle.LeftSpace]: { marginLeft: cssPixelValue(DEFAULT_SIZE) },
    [UtilityStyle.BottomSpace]: { marginBottom: cssPixelValue(DEFAULT_SIZE) },
    [UtilityStyle.TopSpace]: { marginTop: cssPixelValue(DEFAULT_SIZE) },
    [UtilityStyle.RightSpaceMedium]: { marginRight: cssPixelValue(MEDIUM_SIZE) },
    [UtilityStyle.LeftSpaceMedium]: { marginLeft: cssPixelValue(MEDIUM_SIZE) },
    [UtilityStyle.BottomSpaceMedium]: {
        marginBottom: cssPixelValue(MEDIUM_SIZE),
    },
    [UtilityStyle.TopSpaceMedium]: { marginTop: cssPixelValue(MEDIUM_SIZE) },
    [UtilityStyle.RightSpaceSmall]: { marginRight: cssPixelValue(SMALL_SIZE) },
    [UtilityStyle.LeftSpaceSmall]: { marginLeft: cssPixelValue(SMALL_SIZE) },
    [UtilityStyle.TopSpaceSmall]: { marginTop: cssPixelValue(SMALL_SIZE) },
    [UtilityStyle.BottomSpaceSmall]: {
        marginBottom: cssPixelValue(SMALL_SIZE),
    },
    [UtilityStyle.RightSpaceZero]: { marginRight: cssPixelValue(0) },
    [UtilityStyle.LeftSpaceZero]: { marginLeft: cssPixelValue(0) },
    [UtilityStyle.TopSpaceZero]: { marginTop: cssPixelValue(0) },
    [UtilityStyle.BottomSpaceZero]: { marginBottom: cssPixelValue(0) },
    [UtilityStyle.RightSpaceAuto]: { marginRight: "auto !important" },
    [UtilityStyle.LeftSpaceAuto]: { marginLeft: "auto !important" },
    [UtilityStyle.TopSpaceAuto]: { marginTop: "auto !important" },
    [UtilityStyle.BottomSpaceAuto]: { marginBottom: "auto !important" },
    [UtilityStyle.FlexOne]: { flex: "1" },
};
